import "../../styles/sass/main.scss";
import "./header";
import { initSalesTeamFilter } from "./sales-team-filter";
import { initDiagonalCardCut } from "./diagonal-card";

document.addEventListener("DOMContentLoaded", () => {
  initSalesTeamFilter();
  initDiagonalCardCut();
});
